import React from 'react';

import { DefaultItem, MenuItem } from '@adsk/alloy-react-dropdown';
import {
  LogoAutodeskAccIcon,
  LogoAutodeskBim360Icon,
} from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { IconSize } from '../../helpers/filters';

export const DropdownItemWithAvatar = ({
  item,
  ...props
}: {
  item: DefaultItem;
}) => (
  <MenuItem
    {...props}
    text={item.label}
    renderLeftComponent={() =>
      item.value === 'acc' ? (
        <LogoAutodeskAccIcon
          size={IconSize}
          style={{ color: theme.colors.acsLogoBlue }}
        />
      ) : (
        <LogoAutodeskBim360Icon
          size={IconSize}
          style={{ color: theme.colors.adskBlue700 }}
        />
      )
    }
  />
);
